import { MutableRefObject, useCallback, useEffect, useState } from 'react';

/**
 * React hook to track "sticky" elements, i.e. those which appear
 * in fixed position when a page is scrolled past their upper border.
 *
 * Note that to make it work, you need to apply proper CSS classes
 * to a target element, this hooks only detects current scrolling position.
 *
 * @param ref Reference of an element which you want to appear sticky.
 */
export const useSticky = (ref: MutableRefObject<Element | null>): boolean => {
  const [isSticky, setIsSticky] = useState(false);
  const handleScroll = useCallback(() => {
    if (ref.current !== null) {
      setIsSticky(ref.current.getBoundingClientRect().top <= 0);
    }
  }, [ref]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);

  return isSticky;
};
